import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IInlineChatService = ( createDecorator('IInlineChatService'));
export { IInlineChatService };
